<template>
  <div class="goods-pkg" :class="{ sp: isPkgBought }">
    <div class="renew-tips" v-if="disableDate != 'disable' && (disableDate || isPkgBought)">尊贵的VIP用户，您的VIP将于{{ disableDate || packageDetail.disableDate | dateFormat }}到期<a @click="buyProduct">续费VIP</a></div>
    <div class="renew-tips" v-if="disableDate == 'disable'">尊贵的VIP用户，您的VIP课程包已到期哦<a @click="buyProduct">续费VIP</a></div>
    <img class="bimg" src="/images/goods/pkg0.jpg" alt="" />
    <tab-bar></tab-bar>
    <pkg-class :albumList="memberFreeList"></pkg-class>
    <img class="bimg" src="/images/goods/pkg10.jpg" alt="" />
    <!-- <expertList></expertList> -->
    <img class="bimg" src="/images/goods/pkg11.jpg" alt="" />
    <album-list :albumList="memberChargeList"></album-list>
    <img class="bimg" src="/images/goods/pkg12.jpg" alt="" />
    <img class="bimg" src="/images/goods/pkg14.jpg" alt="" />
    <comment></comment>
    <img class="bimg" src="/images/goods/pkg15.jpg" alt="" />
    <div class="instructions">
      <div class="container">
        <p>
          1、智伴优学VIP课程包为虚拟商品，购买前请先阅读VIP课程包购买协议
          <br />2、购买VIP课程包后不支持退款操作，特殊情况请咨询客服<br />3、客服联系方式：400-0004-218
        </p>
      </div>
    </div>
    <pkg-button-bar v-if="packageDetail" :buyState="isPkgBought" :disableDate="disableDate" mode="pkg-detail" @bottomBarHandler="bottomBarHandler">
      <template v-slot:buy>
        <div v-html="isPkgBought || disableDate == 'disable' ? `立即续费 <span class='ico'>¥</span>${packageDetail.price || 0}<span style='font-size:14px;'>/年</span>` : `立即入学 <span class='ico'>¥</span>${packageDetail.price || 0}<span style='font-size:14px;'>/年</span>`"></div>
      </template>
      <template v-slot:vipDetail>
        前往学习儿童VIP课程
      </template>
    </pkg-button-bar>
    <cus-share v-show="shareTipsShow" @cancel="shareTipsShow = false"></cus-share>
    <member-guide v-model="guideShow" @confirm="confirmHReaderTips" :isMember="isPkgBought"></member-guide>
    <button class="receiveVIP" v-if="isVipHandlerSHow" @click="vipHandler">
      领取VIP
    </button>
  </div>
</template>
<script>
// import { SliderItem } from "@/components/member";
import { dateFormat } from '@/utils/filter'
import { Comment, MemberGuide, PkgButtonBar, TabBar, PkgClass, AlbumList, ExpertList } from '@/components/goods'
import { mapGetters, mapMutations } from 'vuex'
import { wechatSharePkgPage } from '@/mixins/wechatShare.js'
import { find, isEmpty } from 'lodash'
// import Browser from '@/utils/browser'

export default {
  mixins: [wechatSharePkgPage],
  filters: { dateFormat },
  components: {
    Comment,
    MemberGuide,
    PkgButtonBar,
    TabBar,
    PkgClass,
    AlbumList,
    ExpertList,
  },
  data() {
    return {
      memberFreeList: [],
      memberChargeList: [],
      packageList: [],
      shareTipsShow: false,
      guideShow: false,
      disableDate: null,
      packageDetail: {},
    }
  },
  created() {
    this.initData()
  },
  watch: {
    userInfo: {
      immediate: true,
      handler: function() {
        this.$setShareConfig(this.getShareText())
      },
    },
    uid: {
      immediate: true,
      handler: function(uid) {
        if (uid) {
          this.$api
            .resource_v1_user_member_package_list({
              params: {
                //儿童礼包
                type: 0,
                channel: 1,
                uid: this.uid,
              },
            })
            .then((list) => {
              if (list.code == 4002) {
                this.disableDate = 'disable'
              } else if (list) {
                this.disableDate = find(list, { type: 0 }) && find(list, { type: 0 }).disableDate
              }
            })
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow',
      setToast: 'setToastShow',
    }),
    initData() {
      this.getGoodsMemberList()
    },
    vipHandler() {
      this.$store.dispatch('externalInterface/navigateTo', {
        name: 'receiveVIP',
      })
    },
    //礼包列表
    getGoodsMemberList() {
      this.setLoading({
        show: true,
      })
      return this.$api
        .payment_v1_goods_member_package_list_get({
          params: {
            channel: 1,
          },
        })
        .then((e) => {
          this.setLoading({
            show: false,
          })
          if (e) {
            this.packageDetail = find(e, { type: 0 })
            this.getGoodsRightsList(this.packageDetail.goodsId)
          }
        })
    },
    //礼包内所有权益 会员课程 付费课程   接口只能获取礼包内所有
    getGoodsRightsList(goodsId) {
      this.$api
        .payment_v1_goods_rights_list_get({
          params: {
            goodsId,
          },
        })
        .then((e) => {
          if (!e) return
          let data0 = e.find((el) => {
            return el.type == 2
            //会员免费专辑
          })
          let data1 = e.find((el) => {
            return el.type == 3
            //会员收费专辑
          })
          this.getGoodsRightsContentList([data0, data1])
        })
    },

    //获取权益下的内容列表
    getGoodsRightsContentList(dataArr, goodsId) {
      let keys = ['memberFreeList', 'memberChargeList']
      let pageSize = [4, 6]
      for (let i = 0; i < dataArr.length; i++) {
        if (!dataArr[i]) continue
        this.$api
          .payment_v1_goods_rights_contents_list_get({
            params: {
              rightsId: dataArr[i].id,
              type: dataArr[i].type,
              pageSize: pageSize[i],
              pageNo: 1,
            },
          })
          .then((e = {}) => {
            this.$set(this, keys[i], e.content)
          })
      }
    },
    shareToInvite() {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/toInvite', {
          params: {
            goodsNum: this.packageDetail.goodsNum,
          },
        })
      } else {
        this.shareTipsShow = true
      }
    },
    async buyProduct() {
      if (!this.isLogin) {
        this.login()
        return
      }
      // if (this.isNative && Browser.isIOS() && this.getVersionControl()) {
      //   this.$store.dispatch('externalInterface/productBuy', {
      //     type: 'package',
      //     goodsNum: this.packageDetail.goodsNum,
      //   })
      // } else {
      this.$router.push(`/goods/checkoutPkg/${this.packageDetail.goodsNum}`)
      // }
    },
    // getVersionControl() {
    //   if (this.headers.deviceType === 'website') return false
    //   return this.headers.deviceDetail.indexOf('4.6.') > -1
    // },
    login() {
      if (this.isNative) {
        this.$store.dispatch('externalInterface/navigateTo', {
          name: 'login',
        })
      } else {
        this.$router.push('/account/login-bySMS')
      }
    },
    bottomBarHandler(flag) {
      let handler = {
        login: this.login,
        share: this.shareToInvite,
        buy: this.buyProduct,
        navigate: () => {
          if (this.isPkgBought) {
            if (this.isNative) {
              this.$store.dispatch('externalInterface/navigateTo', {
                name: 'vipZone',
              })
            } else {
              location.href = this.downloadPath
            }
          } else {
            this.$router.push('/vip/inviteFans?moduleId=1')
          }
        },
      }
      handler[flag]()
    },
    confirmHReaderTips() {
      this.guideShow = false
    },
  },
  computed: {
    ...mapGetters({
      // headers: 'auth/headers',
      userInfo: 'auth/userInfo',
      isVisitor: 'auth/isVisitor',
      isNative: 'externalInterface/isNative',
      uid: 'auth/uid',
      downloadPath: 'externalInterface/downloadApp',
      contextInfo: 'auth/contextInfo',
    }),
    isLogin() {
      return !this.isVisitor && !isEmpty(this.userInfo)
    },
    isVipHandlerSHow() {
      return this.isNative
    },
    isPkgBought() {
      return this.packageDetail.status === 1
    },
  },
}
</script>
<style scoped>
.goods-pkg {
  padding-bottom: 52px;
  background: #fff8f0;
}
.goods-pkg.sp {
  padding-top: 40px;
}

.instructions {
  padding-bottom: 25px;
  background: #fff8f0;
}

.instructions .container {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px 22px;
  width: 311px;
  margin: 0 auto;
}

.instructions .container h4 {
  height: 17px;
  font-size: 12px;
  font-weight: bold;
  color: rgba(64, 64, 64, 1);
  line-height: 17px;
  margin-bottom: 8px;
}

.instructions .container p {
  font-size: 12px;
  color: rgba(64, 64, 64, 1);
  line-height: 20px;
}

.instructions .container p a {
  font-size: 12px;
  color: rgba(64, 64, 64, 1);
}

.goods-pkg >>> .ico {
  font-size: 12px;
}

.goods-pkg >>> .cube-tab-bar {
  margin: 0 32px 20px;
}

.goods-pkg >>> .cube-tab {
  font-size: 16px;
  font-weight: 400;
  color: rgba(182, 182, 182, 1);
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goods-pkg >>> .cube-tab.cube-tab_active {
  color: rgba(116, 179, 250, 1);
}

.goods-pkg >>> .cube-tab-bar-slider {
  width: 16px !important;
  height: 4px;
  background: rgba(116, 179, 250, 1);
  border-radius: 2px;
  left: 16.66%;
  margin-left: -8px;
}
.bimg {
  width: 100vw;
  display: block;
}
.receiveVIP {
  position: fixed;
  width: 99px;
  height: 62px;
  display: block;
  background: url('/images/receive-vip.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-color: transparent;
  right: 0;
  bottom: 52px;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  z-index: 999999999;
}
.renew-tips {
  padding: 0 16px;
  height: 40px;
  line-height: 40px;
  color: #ff6886;
  font-size: 13px;
  display: flex;
  position: fixed;
  top: 0;
  width: 100vw;
  vertical-align: middle;
  background: #fff1e2;
  z-index: 99999;
}
.renew-tips a {
  display: inline-block;
  font-size: 13px;
  line-height: 23px;
  color: #fff;
  height: 28px;
  line-height: 28px;
  width: 65px;
  text-align: center;
  margin: 6px 0 0 auto;
  border-radius: 4px;
  background: linear-gradient(#ff6886, #ff4b6f);
}
</style>
